export default {
    pageTitle: 'Login',
    confirm: 'Confirm',
    cancel: 'Cancel',
    loginPage: {
        qsrsjhm: 'Enter mobile number',
        hqyzm: 'Get verification code',
        wyydty: 'I have read and agree',
        yhxy: 'User Agreement',
        yssm: 'Privacy Policy',
        dlkf: 'Mainland CS',
        xgkf: 'Hong Kong CS',
        qydbgxyhxy: 'Read and agree to User Agreement & Privacy Policy',
        yzmfssb: 'Failed to send code',
        repeatTips: 'No need to resend within 60s',
        请输入正确的手机号: 'Enter valid mobile number',
        loginTitle: 'Login/Register',
        loginDesc: 'First login auto-registers wealth account',
        invitationCode: 'invitation code',
        invitationCodeInputHint: 'Please enter invitation code, letters or numbers',
    },
    sendPage: {
        srdxyzm: 'Enter SMS code',
        yfsdxyzmz: 'SMS code sent to:',
        cxfs: 'Resend',
        sbdyzm: 'Didn‘t receive code',
        nkylxkfjxyzmcx: 'Contact CS for code inquiry.',
        dlkf: 'Mainland CS:',
        xgkf: 'Hong Kong CS:',
        qsrzqdyzmzsyc: 'Invalid or expired code, try again',
        zdl: 'Got it',
        获取语音验证码: 'Get voice code',
        '我们将通过电话语音告知您验证码，请留意接听。': 'We will call with code, please answer.',
        '如仍无法收到，可': 'If still not received,',
        联系客服: 'contact CS',
        '语音验证码已发送，请留意接听电话': 'Voice code sent, please answer.',
        重新获取: 'Resend',
        输入语音验证码: 'Enter voice code',
        我们正在打电话至: 'Calling:',
        电话将提供验证码: ', will provide code',
        '语音验证码获取频率过高，请稍后再试': 'Voice code request too frequent, try later.',
        联系我们: 'Contact us',
    },
    Country: {
        qsrdqgjzss: 'Search by region',
        cydq: 'Common regions',
    },
    fxhlzq: 'Fosun Securities',
    已了解: 'Understood',
    '系统识别该手机号已绑定交易账户。': 'This number is linked to a trading account.',
    '为保障您的账户安全，该类型账户暂不支持网页登录，前往': 'For security, web login not supported. Please',
    下载或打开星财富APP: 'download or open Star Wealth App',
    '，登录您的账户。': 'to log in.',
    resetPwdTips1: 'Multiple accounts linked, web reset not supported. Contact us.',
    resetPwdTips2: 'No account linked, web reset not supported. Contact us.',
    resetPwdTips3: 'Account linked, web reset not supported. Contact us.',
    ryLoginTips1: 'Multiple accounts linked, external login not supported. Contact us.',
    ryLoginTips2: 'Account linked, external login not supported. Contact us.',
    FosunSecuritiesDisclaimer: `Fosun Securities provides asset management products managed by third parties. Fosun Securities does not guarantee product performance. Data and information on this platform are from public sources or authorized third parties.
    Fosun Securities publishes this information for reference only, does not represent any definitive judgment, and does not constitute any recommendation or investment advice.
    Investors should refer to official sources for accurate information and make independent investment decisions based on their own research.
    Platform content is for reference only, verify before use. Invest at your own risk.`,
    inviteFriends: 'Invite Friends',
    inviteList: 'Invite Details',
    inviteActivityList: 'Invite Friends',
    searchInviteActivityList: 'Invite Friends',
    我的邀请码: 'My Invite Code',
    立即邀请: 'Invite Now',
    立即绑定: 'Bind Now',
    修改: 'Modify',
    已绑定: 'Bound',
    '您当前已完成注册，不能绑定注册邀请关系': 'You have completed registration, cannot bind registration invitation relationship',
    '您当前已完成开户，不能绑定开户邀请关系': 'You have completed account opening, cannot bind account opening invitation relationship',
    '您当前已完成首次入金，不能绑定入金邀请关系': 'You have completed first deposit, cannot bind deposit invitation relationship',
    暂无注册邀请人: 'No registration invitation',
    暂无入金邀请人: 'No deposit invitation',
    暂无开户邀请人: 'No account opening invitation',
    注册邀请人: 'Registration Invitation',
    开户邀请人: 'Account Opening Invitation',
    入金邀请人: 'Deposit Invitation',
    绑定邀请人: 'Bind Invitation',
    修改邀请人: 'Modify Invitation',
    '请输入邀请码，字母或数字': 'Enter invitation code, letters or numbers',
    '邀请码为6位数，包含数字或大写字母': 'Invitation code is 6 digits, including numbers or uppercase letters',
    暂无您填写的邀请码: 'Invalid invitation code',
    您的开户邀请人更新为: 'Your account opening invitation updated to',
    您的入金邀请人更新为: 'Your deposit invitation updated to',
    星财号: 'HLID',
    绑定成功: 'Bind Success',
    修改成功: 'Modify Success',
    绑定失败: 'Bind Failed',
    修改失败: 'Modify Failed',
    邀请码: 'Invitation Code',
    邀请人更新确认: 'Invitation Update Confirm',
    不能绑定自己为邀请人: 'Cannot bind to oneself',
    invitee: {
        searchPlaceholder: 'Enter nickname/HLID/phone',
        copySuccess: 'copied',
        copyFail: 'copy failed',
        loading: 'Loading',
        relationChanged: 'Invitation relation changed',
        emptyTips: 'No invited users yet, invite your friends now',
        gotIt: 'Got it',
        noMore: 'No more',
        status: {
            registered: 'Registered',
            opened: 'Opened',
            notOpened: 'notOpend',
            deposited: 'Deposited',
            qualified: 'Asset Qualified',
        },
        profile: {
            myInvites: 'My Invites',
            viewDetail: 'View Details',
            assetQualified: 'Asset Qualified',
            assetQualifiedExplain: 'Asset Qualification Info',
            assetQualifiedDesc: 'Data updates daily at 00:00. Net inflow = transfers in + positions in − transfers out − positions out.',
        },
    },
    inviteActivity: {
        shareInviteLink: 'Share Invite Link',
        rule: 'Event Rules',
        cashRewardTitle1: 'Up to 8,500',
        cashRewardTitle2: 'Cash Voucher Rewards',
        cashRewardDescription1: 'During the event, earn HKD 200 per qualified referral for up to 5 referrals; for 6 or more qualified referrals, earn up to HKD 500 per person',
        cashRewardDescription2: 'Up to 20 referrals',
        riskTips: 'Investing involves risks. Offers are subject to terms and conditions. Please refer to the event rules for details.',
        shareTextTitle: 'Invite you to Star Wealth experience',
        shareTextTitle1: 'The full range of investment categories in Hong Kong——',
        shareTextPoint1: '1.Lifetime Commission-Free US Options',
        shareTextPoint2: '2.HK LV2 Real-time Quotes',
        shareTextPoint3: '3.Diversified asset allocation services',
        shareTextFooter: 'Now deposit to receive rewards, please ensure that you have bound the invitation relationship before depositing, click the link below to participate in the activity:',
        viewMyInvite: 'View My Invites',
    },
}
